import shuffle from 'lodash/shuffle';
import { Model } from '@viddsee/server-api-client';

import { browseApi } from '@/scripts/webcall/v3/browse';
import { VideoRelatedEndpoint } from './VideoRelatedEndpoint';

export class RecommendedVideoRelatedEndpoint extends VideoRelatedEndpoint {
  async getVideos(params = {}): Promise<Model.Pagination.PaginatedItemsResponse<Model.Video.Info> | null> {
    const getVideosPromise = super.getVideos(params) as Promise<Model.Pagination.PaginatedItemsResponse<Model.Video.Info>>;
    const getFeaturedVideoPromise = browseApi.getFeatured().then(r => r.data);

    const [videosResponse, featuredVideo] = await Promise.all([
      getVideosPromise,
      getFeaturedVideoPromise,
    ]);

    let videoItems = shuffle(videosResponse.items);

    if (featuredVideo) {
      let shouldAddFeatured = true;

      for (let i = 0; i < videoItems.length; i++) {
        let item = videoItems[i];
        if (item.id === featuredVideo.id) {
          shouldAddFeatured = false;
          break;
        }
      }

      if (shouldAddFeatured) {
        const featuredVideoIndex = Math.floor(Math.random() * 3); // random index between 0 to 2
        videoItems = [
          ...videoItems.slice(0, featuredVideoIndex),
          featuredVideo,
          ...videoItems.slice(featuredVideoIndex),
        ];
      }
    }
    videosResponse.items = videoItems;

    return videosResponse;
  }
}
